import { type FC } from 'preact/compat';

import { Preloader } from '@/entities/preloader/ui';
import { StopwatchToStart } from '@/entities/stopwatch-to-start';

import { type Game } from '@/shared/api/game/types';

import { Panel } from '@/widget/panel/ui';

interface Props {
  game: Game | null;
  pdOpen: boolean;
  isDev: boolean;
}

export const DefaultLoadingScreen: FC<Props> = ({ game, pdOpen, isDev }) => {
  return (
    <>
      <Preloader pdOpen={pdOpen} />
      {!!game && <Panel pdOpen={pdOpen} game={game} />}
      {isDev && <StopwatchToStart />}
    </>
  );
};
